const { getApiHost } = require('@hotjar/common');
const { hjHash } = require('./hj-hash');
const { b64EncodeUnicode } = require('./hj-encoding');

const self = {};
let linkTag;

// FIXME: Please fix this. You may refer to CFE-266 for more details.
// eslint-disable-next-line func-params-args/func-params
function getWebResourceAPIUrlV2(contentHash, siteId, recordingId, token) {
  const rootUrl = getApiHost();
  let assetUrl = `${rootUrl}/api/v2/sites/${siteId}/recording-id/${recordingId}/web-resource/${contentHash}`;

  if (token) {
    assetUrl += `?token=${token}`;
  }
  return assetUrl;
}

self.findStoredCss = function findStoredCss(
  cssHref,
  { sceneDocument, siteId, recordingId, webResources, token },
) {
  // We retain the actual link tag to avoid creating multiple times.
  if (!linkTag) {
    linkTag = sceneDocument.createElement('link');
    linkTag.rel = 'stylesheet';
  }

  // By setting the href, the actual href will be calculated from relative to absolute URL.
  linkTag.href = cssHref;
  var linkHash = hjHash.md5(b64EncodeUnicode(linkTag.href)); // eslint-disable-line

  let href;
  // WebResources via S3/FileRecording, requires index & content hash.
  webResources.forEach((webResource) => {
    if (webResource.url_hash === linkHash && webResource.content_hash) {
      href = getWebResourceAPIUrlV2(webResource.content_hash, siteId, recordingId, token);
    }
  });

  return href || cssHref;
};

export const WebResource = self;
